import React from 'react';
import './DairyAction.css'

function DairyAction () {
   
        return (
            <div>
                <div className=" operationLogPage">
  <div className="operationLogWrapper">

    {/* <!-- Header --> */}
    <div className="operationLogHeader">
      <h1 className="operationLogTitle">Nhật ký thao tác</h1>

      <div className="operationLogBreadcrumb">
        <span className="operation-logBreadcrumb-text">Trang chủ</span>
        <span className="operationLogBreadcrumbSlash">/</span>

        <span className="operation-logBreadcrumb-text">Nhật ký hệ thống</span>
        <span className="operationLogBreadcrumbSlash">/</span>

        <span className="operation-logBreadcrumb-active">
          Nhật ký thao tác
        </span>
      </div>
    </div>

    {/* <!-- Filter --> */}
    <div className="operationLogFilterBox">

      <div className="row">

        {/* <!-- Time --> */}
        <div className="col-sm-4">
          <div className="operationLogFilterItem">
            <label className="operation-logFilter-label">
              Thời gian
            </label>

            <div className="operationLogDateGroup">

              <div className="operationLogDateInputBox">
                <input
                  type="text"
                  value="20/05/2024 00:00"
                  className="operation-logDate-input"
                />

                <i className="fa-regular fa-calendar operationLogDateIcon"></i>
              </div>

              <div className="operationLogArrow">
                →
              </div>

              <div className="operationLogDateInputBox">
                <input
                  type="text"
                  value="20/05/2024 23:59"
                  className="operation-logDate-input"
                />

                <i className="fa-regular fa-calendar operationLogDateIcon"></i>
              </div>

            </div>
          </div>
        </div>

        {/* <!-- User --> */}
        <div className="col-sm-2">
          <div className="operationLogFilterItem">
            <label className="operation-logFilter-label">
              Người thực hiện
            </label>

            <div className="operationLogSearchBox">
              <input
                type="text"
                value="Nhập tên người dùng..."
                className="operation-log-search-input"
              />

              <i className="fa-solid fa-magnifying-glass operationLogSearchIcon"></i>
            </div>
          </div>
        </div>

        {/* <!-- Chức năng --> */}
        <div className="col-sm-2">
          <div className="operationLogFilterItem">
            <label className="operation-logFilter-label">
              Chức năng
            </label>

            <select className="operation-log-select">
              <option>-- Tất cả --</option>
            </select>
          </div>
        </div>
{/* 
        <!-- Hành động --> */}
        <div className="col-sm-2">
          <div className="operationLogFilterItem">
            <label className="operation-logFilter-label">
              Hành động
            </label>

            <select className="operation-log-select">
              <option>-- Tất cả --</option>
            </select>
          </div>
        </div>

        {/* <!-- Kết quả --> */}
        <div className="col-sm-2">
          <div className="operationLogFilterItem">
            <label className="operation-logFilter-label">
              Kết quả
            </label>

            <select className="operation-log-select">
              <option>-- Tất cả --</option>
            </select>
          </div>
        </div>

      </div>

      <div className="row operationLogFilterSecondRow">

        {/* <!-- IP --> */}
        <div className="col-sm-2">
          <div className="operationLogFilterItem">
            <label className="operation-logFilter-label">
              IP máy
            </label>

            <input
              type="text"
              value="Nhập địa chỉ IP..."
              className="operation-log-normal-input"
            />
          </div>
        </div>

        {/* <!-- Ghi chú --> */}
        <div className="col-sm-4">
          <div className="operationLogFilterItem">
            <label className="operation-logFilter-label">
              Ghi chú
            </label>

            <input
              type="text"
              value="Nhập nội dung ghi chú..."
              className="operation-log-normal-input"
            />
          </div>
        </div>

        {/* <!-- Button --> */}
        <div className="col-sm-6">
          <div className="operationLogButtonGroup">

            <button className="operation-log-reset-button">
              <i className="fa-solid fa-rotate-left icon-log-reset-button"></i>
              Đặt lại
            </button>

            <button className="operation-log-search-button">
              <i className="fa-solid fa-magnifying-glass icon-log-search-button"></i>
              Tìm kiếm
            </button>

          </div>
        </div>

      </div>

    </div>

    {/* <!-- Table --> */}
    <div className="operationLogTableBox">

      <div className="operationLogTableHeader">

        <h2 className="operationLogTableTitle">
          Danh sách nhật ký thao tác
        </h2>

        <div className="operationLogExportGroup">

          <button className="operation-log-excel-button">
            <i className="fa-solid fa-file-excel icon-operation-log-excel-button"></i>
            Export Excel
          </button>

          <button className="operation-log-pdf-button">
            <i className="fa-solid fa-file-pdf icon-operation-log-pdf-button"></i>
            Export PDF
          </button>

          <button className="operationLogSettingButton">
            <i className="fa-solid fa-gear"></i>
          </button>

        </div>

      </div>

      <table className="operationLogTable">

        <thead className="operationLogTableHead">
          <tr className="operationLogTableHeadRow">
            <th className="operationLogTableHeadColumn">STT</th>
            <th className="operationLogTableHeadColumn">Thời gian</th>
            <th className="operationLogTableHeadColumn">Người thực hiện</th>
            <th className="operationLogTableHeadColumn">Chức năng</th>
            <th className="operationLogTableHeadColumn">Hành động</th>
            <th className="operationLogTableHeadColumn">Đối tượng thao tác</th>
            <th className="operationLogTableHeadColumn">Nội dung chi tiết</th>
            <th className="operationLogTableHeadColumn">IP máy</th>
            <th className="operationLogTableHeadColumn">Kết quả</th>
          </tr>
        </thead>

        <tbody className="operationLogTableBody">

          <tr className="operationLogTableBodyRow">
            <td className="operationLogTableBodyColumn">1</td>
            <td className="operationLogTableBodyColumn">20/05/2024 14:32:15</td>
            <td className="operationLogTableBodyColumn">admin</td>
            <td className="operationLogTableBodyColumn">Quản lý người dùng</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogAddStatus">Thêm mới</span>
            </td>
            <td className="operationLogTableBodyColumn">Người dùng: phamvanh</td>
            <td className="operationLogTableBodyColumn">
              Thêm mới người dùng: phamvanh
            </td>
            <td className="operationLogTableBodyColumn">192.168.1.10</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogSuccessStatus">Thành công</span>
            </td>
          </tr>

          <tr className="operationLogTableBodyRow">
            <td className="operationLogTableBodyColumn">2</td>
            <td className="operationLogTableBodyColumn">20/05/2024 14:20:08</td>
            <td className="operationLogTableBodyColumn">nguyenvana</td>
            <td className="operationLogTableBodyColumn">Quản lý vai trò</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogUpdateStatus">Cập nhật</span>
            </td>
            <td className="operationLogTableBodyColumn">Vai trò: Chuyên viên</td>
            <td className="operationLogTableBodyColumn">
              Cập nhật thông tin vai trò: Chuyên viên
            </td>
            <td className="operationLogTableBodyColumn">192.168.1.12</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogSuccessStatus">Thành công</span>
            </td>
          </tr>

          <tr className="operationLogTableBodyRow">
            <td className="operationLogTableBodyColumn">3</td>
            <td className="operationLogTableBodyColumn">20/05/2024 13:15:47</td>
            <td className="operationLogTableBodyColumn">tranthibinh</td>
            <td className="operationLogTableBodyColumn">Quản lý nhóm người dùng</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogDeleteStatus">Xóa</span>
            </td>
            <td className="operationLogTableBodyColumn">Nhóm: Phòng Kế hoạch</td>
            <td className="operationLogTableBodyColumn">
              Xóa nhóm người dùng: Phòng Kế hoạch
            </td>
            <td className="operationLogTableBodyColumn">192.168.1.15</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogSuccessStatus">Thành công</span>
            </td>
          </tr>

          <tr className="operationLogTableBodyRow">
            <td className="operationLogTableBodyColumn">4</td>
            <td className="operationLogTableBodyColumn">20/05/2024 11:05:33</td>
            <td className="operationLogTableBodyColumn">lethicuc</td>
            <td className="operationLogTableBodyColumn">Quản lý dữ liệu</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogUpdateStatus">Cập nhật</span>
            </td>
            <td className="operationLogTableBodyColumn">Dữ liệu: Doanh nghiệp ABC</td>
            <td className="operationLogTableBodyColumn">
              Cập nhật thông tin doanh nghiệp ABC
            </td>
            <td className="operationLogTableBodyColumn">192.168.1.11</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogSuccessStatus">Thành công</span>
            </td>
          </tr>

          <tr className="operationLogTableBodyRow">
            <td className="operationLogTableBodyColumn">5</td>
            <td className="operationLogTableBodyColumn">20/05/2024 10:22:10</td>
            <td className="operationLogTableBodyColumn">admin</td>
            <td className="operationLogTableBodyColumn">Danh mục dùng chung</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogAddStatus">Thêm mới</span>
            </td>
            <td className="operationLogTableBodyColumn">Loại danh mục: Lĩnh vực hoạt động</td>
            <td className="operationLogTableBodyColumn">
              Thêm mới loại danh mục: Lĩnh vực hoạt động
            </td>
            <td className="operationLogTableBodyColumn">192.168.1.10</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogSuccessStatus">Thành công</span>
            </td>
          </tr>

          <tr className="operationLogTableBodyRow">
            <td className="operationLogTableBodyColumn">6</td>
            <td className="operationLogTableBodyColumn">20/05/2024 09:18:55</td>
            <td className="operationLogTableBodyColumn">system</td>
            <td className="operationLogTableBodyColumn">Phân quyền</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogUpdateStatus">Cập nhật</span>
            </td>
            <td className="operationLogTableBodyColumn">Vai trò: Quản trị hệ thống</td>
            <td className="operationLogTableBodyColumn">
              Cập nhật phân quyền cho vai trò: Quản trị hệ thống
            </td>
            <td className="operationLogTableBodyColumn">192.168.1.8</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogSuccessStatus">Thành công</span>
            </td>
          </tr>

          <tr className="operationLogTableBodyRow">
            <td className="operationLogTableBodyColumn">7</td>
            <td className="operationLogTableBodyColumn">20/05/2024 08:45:21</td>
            <td className="operationLogTableBodyColumn">nguyenvana</td>
            <td className="operationLogTableBodyColumn">Quản lý dữ liệu</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogDeleteStatus">Xóa</span>
            </td>
            <td className="operationLogTableBodyColumn">Dữ liệu: Báo cáo thống kê 04/2024</td>
            <td className="operationLogTableBodyColumn">
              Xóa dữ liệu: Báo cáo thống kê 04/2024
            </td>
            <td className="operationLogTableBodyColumn">192.168.1.12</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogFailStatus">Thất bại</span>
            </td>
          </tr>

          <tr className="operationLogTableBodyRow">
            <td className="operationLogTableBodyColumn">8</td>
            <td className="operationLogTableBodyColumn">20/05/2024 08:30:12</td>
            <td className="operationLogTableBodyColumn">tranthibinh</td>
            <td className="operationLogTableBodyColumn">Cấu hình hệ thống</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogUpdateStatus">Cập nhật</span>
            </td>
            <td className="operationLogTableBodyColumn">Cấu hình email</td>
            <td className="operationLogTableBodyColumn">
              Cập nhật cấu hình máy chủ email
            </td>
            <td className="operationLogTableBodyColumn">192.168.1.15</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogSuccessStatus">Thành công</span>
            </td>
          </tr>

          <tr className="operationLogTableBodyRow">
            <td className="operationLogTableBodyColumn">9</td>
            <td className="operationLogTableBodyColumn">20/05/2024 08:15:30</td>
            <td className="operationLogTableBodyColumn">admin</td>
            <td className="operationLogTableBodyColumn">Sao lưu dữ liệu</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogExecuteStatus">Thực thi</span>
            </td>
            <td className="operationLogTableBodyColumn">Sao lưu hệ thống</td>
            <td className="operationLogTableBodyColumn">
              Thực hiện sao lưu dữ liệu hệ thống
            </td>
            <td className="operationLogTableBodyColumn">192.168.1.10</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogSuccessStatus">Thành công</span>
            </td>
          </tr>

          <tr className="operationLogTableBodyRow">
            <td className="operationLogTableBodyColumn">10</td>
            <td className="operationLogTableBodyColumn">20/05/2024 07:58:44</td>
            <td className="operationLogTableBodyColumn">lethicuc</td>
            <td className="operationLogTableBodyColumn">Tích hợp hệ thống</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogUpdateStatus">Cập nhật</span>
            </td>
            <td className="operationLogTableBodyColumn">Kết nối: Cổng DVCQG</td>
            <td className="operationLogTableBodyColumn">
              Cập nhật thông tin kết nối Cổng DVCQG
            </td>
            <td className="operationLogTableBodyColumn">192.168.1.11</td>
            <td className="operationLogTableBodyColumn">
              <span className="operationLogSuccessStatus">Thành công</span>
            </td>
          </tr>

        </tbody>

      </table>

      {/* <!-- Footer --> */}
      <div className="operationLogFooter">

        <div className="operationLogFooterLeft">

          <span className="operation-log-footer-text">
            Hiển thị
          </span>

          <select className="operation-log-footer-select">
            <option>10</option>
          </select>

          <span className="operation-log-footer-text">
            dòng trên mỗi trang
          </span>

        </div>

        <div className="operationLogFooterRight">

          <span className="operation-log-pagination-info">
            1 - 10 trong 256
          </span>

          <div className="operationLogPagination">

            <button className="operationLogPaginationButton">
              «
            </button>

            <button className="operationLogPaginationButton">
              ‹
            </button>

            <button className="operationLogPaginationActive">
              1
            </button>

            <button className="operationLogPaginationButton">
              2
            </button>

            <button className="operationLogPaginationButton">
              3
            </button>

            <button className="operationLogPaginationButton">
              ...
            </button>

            <button className="operationLogPaginationButton">
              26
            </button>

            <button className="operationLogPaginationButton">
              ›
            </button>

            <button className="operationLogPaginationButton">
              »
            </button>

          </div>

        </div>

      </div>

    </div>

  </div>
</div>
            </div>
        );
    
}



export default DairyAction;